export class ERRORS {
    static get GENERAL_ERROR() {
        return {
            code: 0,
            message: 'General error occured'
        };
    }

    static get INVALID_REPLY_ESB() {
        return {
            code: 0,
            message: 'Please try again',
            dev_message: 'The ESB gave a wrong message or the request failed.'
        };
    }
}



// WEBPACK FOOTER //
// ./src/modules/vualto/vualto_errors.js